<template>
  <!-- @mouseleave="handleMouseleave"
    @mouseenter="handleMouseenter"
    @touchstart="handleMouseenter" -->
  <div
    ref="soundbtn"
    class="btn-sound btnsound"
  >
    <div
      class="btnsound_icon_container"
      @click="toggleSound"
    >
      <div
        class="mdi btnsound_icon mdi-volume-off"
        :style="`--icon-opacity:${soundIcon === 'off' ? 1 : 0}`"
      ></div>
      <div
        class="mdi btnsound_icon mdi-volume-medium"
        :style="`--icon-opacity:${soundIcon === 'off' ? 0 : 1}`"
      ></div>
      <div
        class="mdi btnsound_icon mdi-volume-high"
        :style="`--icon-opacity:${soundIcon === 'high' ? 1 : 0}`"
      ></div>
    </div>
    <div
      class="btnsound_range_container"
      style="position: fixed; z-index: 10; overflow: hidden"
      @wheel.stop="handleWheel"
      @mousedown="handleMousedown"
      @touchstart="handleMousedown"
    >
      <!-- :class="{ btnsound_range_container_visible: mousedown || mouseover }" -->
      <!-- ref="rangecont" -->
      <div
        ref="range"
        class="btnsound_range"
      >
        <div
          class="btnsound_range_dot"
          :style="`left:${muted ? 0 : volume * 100}%`"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { throttle, debounce } from 'lodash'
import { nextTick } from 'vue'

export default {
  name: 'BtnSound',
  // mixins: [float_mix],
  props: {},
  data() {
    return {
      open: false,

      mousedown: false,
      mouseover: false,
      startVolume: 0,
    }
  },
  beforeUnmount() {
    this.removeEventListeners()
  },
  methods: {
    removeEventListeners() {
      window.removeEventListener('mousemove', this.handleMousemove)
      window.removeEventListener('touchmove', this.handleMousemove)
      window.removeEventListener('mouseup', this.handleMouseup)
      window.removeEventListener('touchend', this.handleMouseup)
    },
    addEventListeners() {
      window.addEventListener('mousemove', this.handleMousemove)
      window.addEventListener('touchmove', this.handleMousemove)
      window.addEventListener('mouseup', this.handleMouseup)
      window.addEventListener('touchend', this.handleMouseup)
    },
    handleMouseup() {
      this.mousedown = false
      this.setPersits()
      this.removeEventListeners()
    },
    handleMousedown(e) {
      this.mousedown = true
      this.mouseover = true
      this.startVolume = this.volume
      this.addEventListeners()
      this.handleMousemove(e)
    },
    // handleMouseleave() {
    //   this.mouseover = false
    //   // this.mouseover = true
    // },
    // handleMouseenter() {
    //   this.mouseover = true
    //   // this.positionRange()
    // },
    // positionRange() {
    //   let referenceEl = this.$refs.soundbtn
    //   let element = this.$refs.rangecont
    //   let options = {
    //     padding: 0,
    //     offset: 0,
    //     placement: this.$store.getters.globals_mobile ? 'bottom' : 'right',
    //   }
    //   // let options = { padding: 0, offset: 0, placement: 'bottom' }
    //   // this.fl_setPositionStyle({ referenceEl, element, options })
    // },
    handleMousemove: throttle(function (e) {
      e.preventDefault()
      let { clientX } = e
      if (e?.touches) {
        clientX = e?.touches[0]?.clientX
      }
      const { width, left, right } = this.$refs.range.getBoundingClientRect()
      const res = clientX <= left ? 0 : clientX >= right ? 1 : (clientX - left) / width
      this.setVolume(res)
    }, 1),
    handleWheel(e) {
      e.preventDefault()
      if (!this.volume) return
      const delta = Math.abs(e.deltaY) > Math.abs(e.deltaX) ? e.deltaY : e.deltaX * -1
      let res = this.volume + (delta < 0 ? 0.0075 : -0.0075)
      res = res <= 0 ? 0 : res >= 1 ? 1 : res
      this.setVolume(res)
    },
    toggleSound() {
      this.$store.commit('sounds_set_muted', !this.muted)
      if (this.volume === 0) {
        this.$store.commit('sounds_set_volume', 1)
      }
      this.playVolumePrompt()
      this.setPersits()
    },
    playVolumePrompt: debounce(function () {
      this.$store.dispatch('sounds_play', 'sound_volume')
    }, 77),
    setVolume(v) {
      if (v === 0) {
        this.$store.commit('sounds_set_muted', true)
        this.$store.commit('sounds_set_volume', this.startVolume)
        return
      }
      if (this.muted) {
        this.$store.commit('sounds_set_muted', false)
      }
      this.$store.commit('sounds_set_volume', v)
      nextTick(() => {
        this.playVolumePrompt()
      })
    },
    setPersits() {
      localStorage.setItem('sound_volume', this.volume)
      localStorage.setItem('sound_muted', this.muted)
    },
  },
  computed: {
    volume() {
      return this.$store.getters.sounds_volume
    },
    muted() {
      return this.$store.getters.sounds_muted
    },
    soundIcon() {
      if (this.muted) {
        return 'off'
      }
      if (this.volume > 0.5) {
        return 'high'
      }
      return 'medium'
    },
  },
}
</script>
<style lang="scss" scoped>
.btnsound {
  --dot-dimension: 1rem;
  --icon-size: 1.5rem;
  --icon-container-width: 1.4rem;
  --icon-opacity: 1;
  --slider-height: 4px;
  --slider-opacity: 0;
  // --slider-opacity: 0.5;
  --clr-range-back: var(--clr-black-2);
  --clr-back-overlay: var(--clr-black-2);
  --range-position: fixed;

  display: flex;
  align-items: center;
  // justify-content: center;
  justify-content: flex-end;
  gap: 0.75rem;
  cursor: pointer;
  position: relative;
  // padding: 0 0.125rem;
  &_icon {
    &_container {
      margin: auto;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: var(--icon-container-width);
      height: var(--slider-height);
      // background: red;
    }
    opacity: var(--icon-opacity);
    line-height: 1;
    // z-index: var(--icon-opacity);
    transition: opacity 0.22s;
    font-size: var(--icon-size);
    position: absolute;
    z-index: 2;
    display: flex;
    // background: rgba(255, 0, 0, 0.411);
    &.mdi-volume-medium {
      &:before {
        position: relative;
        left: -0.165rem;
      }
    }
  }
  .btnsound_range {
    &_container {
      z-index: 1;
      position: var(--range-position);
      display: flex;
      align-items: center;
      justify-content: center;
      width: 0;
      height: inherit;
      // overflow: hidden;
      background: var(--clr-range-back);
      border-radius: 4px;
      pointer-events: none;
      // &_visible {
      //   &:hover {
      //     pointer-events: auto;
      //     width: 8rem;
      //     transform: translate(100%, 0);
      //     // justify-self: flex-end;
      //     overflow: unset;
      //     &::before {
      //       content: '';
      //       width: 100%;
      //       height: 100%;
      //       border-radius: 4px;
      //       left: -4px;
      //       top: 0;
      //       position: absolute;
      //       background: var(--clr-back-overlay);
      //     }
      //     .btnsound_range {
      //       --slider-opacity: 1;
      //       max-width: 6rem;
      //       overflow: unset;
      //     }
      //   }
      // }
    }
    transition: 0.22s;
    opacity: var(--slider-opacity);
    max-width: 0;
    width: 6rem;
    left: 1rem;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    &::after,
    &:before {
      content: '';
      width: calc(100% + calc(1 * var(--dot-dimension)));
      left: calc(-0.5 * var(--dot-dimension));
      position: absolute;
    }
    &::after {
      height: 100%;
      top: 0;
    }
    &::before {
      height: var(--slider-height);
      background: var(--clr-white-0);
      border-radius: 4px;
    }
    &_dot {
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      &:before {
        content: '';
        width: var(--dot-dimension);
        height: var(--dot-dimension);
        background: var(--clr-white-0);
        // background: var(--clr-primary);
        border-radius: 50%;
        position: absolute;
      }
    }
  }
  &:hover {
    .btnsound_range_container {
      pointer-events: auto;
      width: 8rem;
      transform: translate(100%, 0);
      // justify-self: flex-end;
      overflow: unset;
      &::before {
        content: '';
        width: 100%;
        height: 100%;
        border-radius: 4px;
        left: -4px;
        top: 0;
        position: absolute;
        background: var(--clr-back-overlay);
      }
      .btnsound_range {
        --slider-opacity: 1;
        max-width: 6rem;
        overflow: unset;
      }
    }
  }
  // &:hover {
  // }
}

@media (max-width: 1023px) {
  .btnsound {
    &:hover {
      .btnsound_range_container {
        transform: translate(25%, -100%);
      }
    }
  }
}

@media (max-width: 520px) {
  .btnsound {
    &:hover {
      .btnsound_range_container {
        transform: translate(100%, 0);
      }
    }
  }
  // .btnsound {
  //   .btnsound_range_container {
  //     pointer-events: auto;
  //     width: 8rem;
  //     transform: translate(100%, 0) !important;
  //     // justify-self: flex-end;
  //     overflow: unset;
  //     &::before {
  //       content: '';
  //       width: 100%;
  //       height: 100%;
  //       border-radius: 4px;
  //       left: -4px;
  //       top: 0;
  //       position: absolute;
  //       background: var(--clr-back-overlay);
  //     }
  //     .btnsound_range {
  //       --slider-opacity: 1;
  //       max-width: 6rem;
  //       overflow: unset;
  //     }
  //   }
  // }
}
</style>
